import { useState, useRef } from "react";
import { ImageModel } from "../data/entities";
import { showErrorMessage } from "../utils";

interface UseMediaUploaderProps {
  uploadHandler: (image: ImageModel) => Promise<void>;
  removeHandler: () => Promise<void>;
  onUploadSuccess?: () => void;
}

export function useMediaUploader({ uploadHandler, removeHandler, onUploadSuccess }: UseMediaUploaderProps) {
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    setSelectedImage(file);

    if (file) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        if (typeof reader.result === 'string') {
          const base64Image = reader.result.replace('data:', '').replace(/^.+,/, '');
          const image = {
            data: base64Image,
            fileName: file.name,
            fileType: file.type,
          } as ImageModel;

          try {
            await uploadHandler(image);
            onUploadSuccess?.();
          } catch (error) {
            console.error('Error uploading image:', error);
            showErrorMessage('Error uploading image');
          }
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDeleteClick = async () => {
    try {
      await removeHandler();
    } catch (error) {
      console.error('Error removing image:', error);
      showErrorMessage('Error removing image');
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  return {
    selectedImage,
    fileInputRef,
    handleFileChange,
    handleDeleteClick,
    handleUploadClick,
  };
}